import Endpoints from '@/config/ApiEndpoints.js';	
import Axios from 'axios';
import $ from 'jquery'; 
import UpcomingEvent from '@/pages/upcomingevent/upcomingevent';
import AssetOverView from '@/pages/assets/assetoverview/assetoverview';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Task from "@/pages/task/task";
import VehicleMaps from '@/pages/vehicles/vehiclemaps/vehiclemaps.vue';
var moment = require("moment");
export default {
	components:{
		UpcomingEvent,
		VuePerfectScrollbar,
		AssetOverView,
		Task,
		VehicleMaps,
	},
	filters: {
        date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
				sendDate = moment(data).format("DD-MM-YYYY");
			}
			return sendDate;
        },
    },
	data() {
		return {
			trackingModule: false,
			ShowVehiclePositionModel: false,
			settings4: {
				maxScrollbarLength: 60,
				suppressScrollY: true,
			},
			CompanyData:"",
			SearchLoader: false,
			ShowLoader: false,
			UnsafeShowLoader: false,
			SearchKey: '',
			VehicleImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
			ImageEndpoint: Endpoints.Helper.Image+ '/',
			Assets:[],
			Make:{},
			Models:{},
			AssetTypes:{},
			Groups:{},
			Categories:{},
			UpcomingEvent: {},
			DashboardData: {},
			AssetUnSafeArr:{},
			DashboardDetailHeading:'',
			VehicleWarningCnt: 0,
			SearchData:{
				type:"",
				make:"",
				model:"",
				group:"",
				category:"",
				branch_id:"",
				missing_status:"",
			},
			ActivityPage: 1,
			LastPageRequest: 0,
			ShowUrgentTask: false,
			ShowAssetsDetails: false,
			Branches: {},
			ShowAssignmentModel:false,
			ViewAssets: {},
			showLocationDetails:false,
			locationPoints: "",
			center: {
				lat: 55.232753,
				lng: -3.944403,
			},
			infoOptions: {
				pixelOffset: {
				width: 0,
				height: -35,
				},
				content: "",
			},
			todaysUrgentTaskNew: window.todaysUrgentTaskNew,
		}
	},	
	mounted() {		
		var AccountPermissions = JSON.parse(localStorage.getItem("AccountPermissions"));
		this.FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
		var FleetSubscriptionModules = JSON.parse(this.FleetSubscription.fleet_modules);
		if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)){
			this.$router.push('/');
		}		    	
		const isTracking = FleetSubscriptionModules['Assets Tracking'];
		if (isTracking) {
			this.trackingModule = true;
		}		

		if (AccountPermissions && 
			AccountPermissions.Assets &&
			AccountPermissions.Assets.enable) {
			if ( AccountPermissions.Assets.view) {
				this.ShowAssetsDetails = true;
			}
		}
		
		if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}
		this.ShowAssetsDetails = true;
		if (!FleetSubscriptionModules["Hierarchy System"]) {
			this.ShowUrgentTask = true;
			this.ShowAssetsDetails = true;
		}
		this.CompanyData = JSON.parse(localStorage.getItem("Company")); 
		if (this.CompanyData && this.CompanyData.name) {            
		  if(window.taskModuleCompanies.includes(this.CompanyData.id)){
	      	this.todaysUrgentTaskNew = true
	      }
	    } 

		
		this.GetUnSafeAsset();			
		this.GetAssetsList();
		this.GetMake();
		this.GetModel();
		this.GetAssetsTypes();
		this.GetGroups();
		this.GetCategories();
		this.GetBranches();
	},
	methods : {
		GetUnSafeAsset() {
			this.UnsafeShowLoader = true;
			Axios.post(Endpoints.Assets.GetUnsafeAsset, {
			  token: localStorage.getItem("token"),
			}).then((Response) => {
			  if (Response.data.success) {
				this.UnsafeShowLoader = false;
				this.AssetUnSafeArr = Response.data.UnSafeRecords;
			  }
			});
		  },
		ShowLocationMap(Details) {
			this.showLocationDetails = true;
			const marker = {
			  lat: parseFloat(Details.latitude),
			  lng: parseFloat(Details.longitude),
			};
			this.center = marker,
			this.locationPoints = marker;
			this.infoOpened = true;
			this.infoOptions.content =
			  '<div id="mapcontent"><h5 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
			  Details.name +
			  "</h5></div>";
		},
		ShowAssetsPosition(AssetData) {
	    	this.ShowVehiclePositionModel = true;      
	    	setTimeout(() => {
	    		this.$refs.VehicleMaps.SetAssetsId(AssetData.id)
	    		this.$refs.VehicleMaps.ShowVehicleMaps()
	    	},500);
    	},
		handleScroll() {
			let scrollBottom = document.body.scrollHeight;
			let bottomOfWindow = scrollBottom >= window.scrollY;
			if (bottomOfWindow) {
				this.GetAssetsList();
			}
		},
		GetBranches(){
			var obj = { token: localStorage.getItem("token"), select_branch:true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
			  if (Response.data.success) {
				this.Branches = Response.data.records;
			  }
			});
		  },
		GetGroups(){
			var obj = { token: localStorage.getItem("token") };
			Axios.post(Endpoints.Assets.Group.List, obj).then((Response) => {
				if (Response.data.success) {
					this.Groups = Response.data.GroupList;
				}
			});
		},
		GetCategories(){
			var obj = { token: localStorage.getItem("token") };
			Axios.post(Endpoints.Assets.Category.List, obj).then((Response) => {
				if (Response.data.success) {
					this.Categories = Response.data.CategoryList;
				}
			});
		},
		GetMake(){
			var obj = { token: localStorage.getItem("token") };
			obj.field = 'make';
			Axios.post(Endpoints.Assets.GetAssetsFieldValues, obj).then((Response) => {
				if (Response.data.success) {
					this.Make = Response.data.records;
				}
			});
		},
		GetModel(){			
			var obj = { token: localStorage.getItem("token")};
			obj.field = 'model';
			Axios.post(Endpoints.Assets.GetAssetsFieldValues, obj).then((Response) => {
				if (Response.data.success) {
					this.Models = Response.data.records;
				}
			});
		},
		GetAssetsTypes(){
			var obj = { token: localStorage.getItem("token") };
			obj.field = 'type';
			Axios.post(Endpoints.Assets.GetAssetsFieldValues, obj).then((Response) => {
				if (Response.data.success) {
					this.AssetTypes = Response.data.records;
				}
			});
		},
		SearchAssets(){
			this.Assets = [];
			this.ActivityPage = 1;
			this.LastPageRequest = 0;
			this.GetAssetsList('search');
		},
		GetAssetsList(type=''){
			var self = this;
      	 	if (this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) {
				this.SearchLoader = true;
				this.LastPageRequest = this.ActivityPage;
				var obj = {
					token: localStorage.getItem("token"),
				};
				if(type=='search'){
					if(this.SearchKey != ""){
						obj.searchkey = this.SearchKey
					}
					obj.SearchData = this.SearchData;
				}
				this.ShowLoader=true;
				Axios.post(Endpoints.Assets.List, obj).then((Response) => {
					this.ShowLoader=false;
					if (Response.data.success) {
						this.SearchLoader = false;	
						this.Assets = Response.data.AssetsList;
					}
				});
			}
		},
		ViewAssignment(AssetsData){
			this.ViewAssets = AssetsData;
			this.ShowAssignmentModel = true;
		}
	},
	
}